import {AuthModel} from '../../models'
import {userAPI} from '../../api'

const AUTH_LOCAL_STORAGE_KEY = 'fanar-auth-react-v'
const FIRST_REFERRER_LOCAL_STORAGE_KEY = 'fanar-first-referrer-react-v'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const saveReferrer = () => {
  const referrer = document.referrer;
  if (!localStorage.getItem(FIRST_REFERRER_LOCAL_STORAGE_KEY) && referrer) {
    localStorage.setItem(FIRST_REFERRER_LOCAL_STORAGE_KEY, referrer);
  }
}

const getReferrer = () => {
  return localStorage.getItem(FIRST_REFERRER_LOCAL_STORAGE_KEY);
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const getUesr = async () => {
  const {data: data} = await userAPI.getProfile()
  return data['data']
}

export {getAuth, setAuth, removeAuth, saveReferrer, getReferrer, AUTH_LOCAL_STORAGE_KEY, getUesr}
